import { supabase } from "@/lib/supabase";

/** Root segment for TanStack Query — use with `invalidateQueries({ queryKey: [ADMIN_OPEN_ISSUES_QUERY_KEY] })`. */
export const ADMIN_OPEN_ISSUES_QUERY_KEY = "admin-open-issues" as const;

export function getAdminOpenIssuesQueryKey(orgId: string) {
  return [ADMIN_OPEN_ISSUES_QUERY_KEY, orgId] as const;
}

export const ADMIN_OPEN_ISSUES_PAGE_SIZE = 10;

/** Row shape for open issues list on admin dashboard (nested selects). */
export interface AdminOpenIssueRow {
  id: string;
  location_id: string | null;
  description: string | null;
  photo_url: string | null;
  reporter_id: string | null;
  status: string | null;
  notification_status: string | null;
  released_from_cleaning_at: string | null;
  created_at: string | null;
  cleaning_locations?: {
    address: string;
    auto_notify_issues: boolean | null;
  } | null;
  reporter?: {
    full_name: string | null;
  } | null;
}

export async function fetchAdminOpenIssuesPage(
  orgId: string,
  pageIndex: number
): Promise<AdminOpenIssueRow[]> {
  const from = pageIndex * ADMIN_OPEN_ISSUES_PAGE_SIZE;
  const to = from + ADMIN_OPEN_ISSUES_PAGE_SIZE - 1;

  const { data, error } = await supabase
    .from("property_issues")
    .select(
      `
          id,
          location_id,
          description,
          photo_url,
          reporter_id,
          status,
          notification_status,
          released_from_cleaning_at,
          created_at,
          cleaning_locations (
            address,
            auto_notify_issues
          ),
          reporter:profiles!property_issues_reporter_id_fkey (
            full_name
          )
        `
    )
    .eq("org_id", orgId)
    .eq("source", "cleaning")
    .is("released_from_cleaning_at", null)
    .eq("status", "pending_cleaning_review")
    .order("created_at", { ascending: false })
    .range(from, to);

  if (error) {
    console.error("[fetchAdminOpenIssuesPage]", error);
    throw error;
  }

  return (data as AdminOpenIssueRow[]) ?? [];
}
